var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("snt-select", {
    staticClass: "barcode-select",
    attrs: {
      items: _vm.items,
      placeholder: "โปรดเลือก",
      name: "barcode-type",
      outlined: "",
      dense: "",
      "hide-details": "",
    },
    on: {
      input: function ($event) {
        return _vm.onChange($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }